import React from "react"
import PropTypes from "prop-types"
import { SortDirection } from "react-virtualized"

import UtilizationRangeFilter from "../UtilizationRangeFilter"
import UtilizationUnitDetailTableWithData from "./UtilizationUnitDetailTableWithData"
import CalendarDropdownWithStore from "../Calendar"
import DepartmentDropdown from "../DepartmentDropdown"
import SearchBox from "../SearchBox"
import UtilizationDetailCardsWithData from "../UtilizationDetailCards/UtilizationDetailCardsWithData"

import "./UtilizationUnitDetailTableControlled.scss"

class UtilizationUnitDetailTableControlled extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      filters: ["all"],
      searchValue: "",
      sortBy: "unitName",
      sortDirection: SortDirection.ASC,
      selectedDepartment: undefined,
    }
  }

  handleDepartmentChange = selectedDepartment => {
    if (selectedDepartment.value === null) selectedDepartment = undefined
    this.setState({ selectedDepartment })
  }

  handleSearchChange = query => {
    this.setState({ searchValue: query })
  }

  handleSortChange = column => {
    this.setState(prevState => ({
      sortBy: column,
      sortDirection:
        prevState.sortBy === column &&
        prevState.sortDirection === SortDirection.ASC
          ? SortDirection.DESC
          : SortDirection.ASC,
    }))
  }

  handleFilterChange = clickedKey => {
    this.setState(prevState => {
      let selected
      if (clickedKey === "all") {
        selected = ["all"]
      } else if (prevState.filters.includes(clickedKey)) {
        selected = prevState.filters.filter(item => item !== clickedKey)
      } else {
        selected = [clickedKey, ...prevState.filters].filter(
          item => item !== "all"
        )
      }

      if (selected.length === 0 || selected.length >= 4) selected = ["all"]

      return { filters: selected }
    })
  }

  searchUsingDeviceTypeName = () => {
    this.props.filterToExactDeviceType(this.props.deviceTypeId)
    this.props.navigateToLocator()
  }

  render() {
    return (
      <div className="UtilizationUnitDetailTableControlled">
        <div className="subheader">
          <div className="left-header">
            <a id="back-to-all-assets" href=".">
              <h3> &lt; back to all assets</h3>
            </a>
            <h1>{this.props.deviceName}</h1>
          </div>
          <CalendarDropdownWithStore />
        </div>
        <div className="controls">
          <div className="owned-by">
            <span>View Assets owned by</span>
            <DepartmentDropdown
              loading={this.props.loading}
              departments={this.props.departments}
              departmentUpdated={this.handleDepartmentChange}
            />
          </div>
          <button
            className="locate-device-button"
            onClick={this.searchUsingDeviceTypeName}
          >
            Locate {this.props.deviceName}
          </button>
        </div>
        <UtilizationDetailCardsWithData
          loading={this.props.loading}
          entityId={this.props.defaultEntityId}
          owningDeptId={
            this.state.selectedDepartment
              ? this.state.selectedDepartment.value
              : undefined
          }
          entityType={this.props.defaultEntityType}
          deviceTypeId={this.props.deviceTypeId}
        />
        <div className="controls">
          <UtilizationRangeFilter
            selected={this.state.filters}
            handleChange={this.handleFilterChange}
          />
          <SearchBox
            onChange={this.handleSearchChange}
            query={this.state.searchValue}
          />
        </div>
        <UtilizationUnitDetailTableWithData
          loading={this.props.loading}
          entityId={this.props.defaultEntityId}
          owningDeptId={
            this.state.selectedDepartment
              ? this.state.selectedDepartment.value
              : undefined
          }
          entityType={this.props.defaultEntityType}
          deviceTypeId={this.props.deviceTypeId}
          deviceName={this.props.deviceName}
          onSortChange={this.handleSortChange}
          sortBy={this.state.sortBy}
          sortDirection={this.state.sortDirection}
          filters={this.state.filters}
          searchValue={this.state.searchValue}
        />
      </div>
    )
  }
}

UtilizationUnitDetailTableControlled.propTypes = {
  deviceName: PropTypes.string,
  deviceTypeId: PropTypes.string,
  defaultEntityId: PropTypes.string,
  defaultEntityType: PropTypes.oneOf(["facility", "department"]),
  departments: DepartmentDropdown.propTypes.departments,
  loading: PropTypes.bool,
  filterToExactDeviceType: PropTypes.func,
  navigateToLocator: PropTypes.func,
}

export default UtilizationUnitDetailTableControlled
